class LowStockCollectionFilter {
  static cache = new Map();
  static requestId = 0;

  static isActive() {
    return new URLSearchParams(window.location.search).get('low_stock') === '1';
  }

  static syncControls() {
    const active = LowStockCollectionFilter.isActive();

    document.querySelectorAll('[data-low-stock-checkbox]').forEach((checkbox) => {
      checkbox.checked = active;
    });
  }

  static getPageCount(doc) {
    let pageCount = 1;

    doc.querySelectorAll('.pagination a[href]').forEach((link) => {
      const page = Number(new URL(link.href, window.location.origin).searchParams.get('page') || 1);
      pageCount = Math.max(pageCount, page);
    });

    return pageCount;
  }

  static getProducts(doc) {
    return Array.from(doc.querySelectorAll('#product-grid [data-low-stock-product][data-low-stock-eligible="true"]'));
  }

  static getSectionUrl(page) {
    const grid = document.getElementById('product-grid');
    const url = new URL(window.location.href);

    url.searchParams.set('section_id', grid.dataset.id);
    url.searchParams.set('page', page);

    return url.toString();
  }

  static async fetchPage(page) {
    const url = LowStockCollectionFilter.getSectionUrl(page);

    if (!LowStockCollectionFilter.cache.has(url)) {
      LowStockCollectionFilter.cache.set(
        url,
        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`Low stock page request failed: ${response.status}`);
            return response.text();
          })
          .then((html) => new DOMParser().parseFromString(html, 'text/html'))
      );
    }

    return LowStockCollectionFilter.cache.get(url);
  }

  static setLoading(isLoading) {
    const collection = document.querySelector('#ProductGridContainer .collection');
    const grid = document.getElementById('product-grid');

    collection?.classList.toggle('loading', isLoading);
    if (grid) grid.setAttribute('aria-busy', String(isLoading));
  }

  static updateCount(count) {
    const text = `${count} ${count === 1 ? 'product' : 'products'}`;

    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const container = document.getElementById(id);
      if (container) {
        container.textContent = text;
        container.classList.remove('loading');
      }
    });

    document.querySelectorAll('[data-low-stock-label]').forEach((label) => {
      label.textContent = `Low stock (${count})`;
    });
  }

  static render(products) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.replaceChildren(...products.map((product) => product.cloneNode(true)));
    document.querySelector('#ProductGridContainer .pagination-wrapper')?.remove();

    if (products.length === 0) {
      const emptyItem = document.createElement('li');
      emptyItem.className = 'grid__item low-stock-filter__empty';
      emptyItem.textContent = 'No low stock products found.';
      grid.appendChild(emptyItem);
    }

    LowStockCollectionFilter.updateCount(products.length);
  }

  static async refresh() {
    const requestId = ++LowStockCollectionFilter.requestId;
    LowStockCollectionFilter.syncControls();

    if (!LowStockCollectionFilter.isActive() || !document.getElementById('product-grid')) {
      LowStockCollectionFilter.setLoading(false);
      return;
    }

    LowStockCollectionFilter.setLoading(true);

    try {
      let firstDocument = document;
      const currentPage = Number(new URLSearchParams(window.location.search).get('page') || 1);

      if (currentPage !== 1) {
        firstDocument = await LowStockCollectionFilter.fetchPage(1);
      }

      const pageCount = LowStockCollectionFilter.getPageCount(firstDocument);
      const remainingPages = [];

      for (let page = 2; page <= pageCount; page += 1) {
        remainingPages.push(LowStockCollectionFilter.fetchPage(page));
      }

      const documents = [firstDocument, ...(await Promise.all(remainingPages))];
      if (requestId !== LowStockCollectionFilter.requestId) return;

      LowStockCollectionFilter.render(documents.flatMap(LowStockCollectionFilter.getProducts));
    } catch (error) {
      if (requestId !== LowStockCollectionFilter.requestId) return;

      console.error(error);
      LowStockCollectionFilter.render(LowStockCollectionFilter.getProducts(document));
    } finally {
      if (requestId === LowStockCollectionFilter.requestId) {
        LowStockCollectionFilter.setLoading(false);
      }
    }
  }
}

window.LowStockCollectionFilter = LowStockCollectionFilter;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => LowStockCollectionFilter.refresh());
} else {
  LowStockCollectionFilter.refresh();
}
